import t from 'react-translate';
import NvModal, { ModalType } from 'shared/components/nv-modal';
import { config } from '@config/pendo.config.json';
import { useContext, useState, useRef } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { BrowseMentorsModalProps } from './types';
import { getMentoringProgramAliases } from 'redux/selectors/mentoring-programs';
import MentoringProgramContext from 'athena/components/mentoring-program/context';
import { useSelector } from 'react-redux';
import BrowseMentorsHeader from './browse-mentors-header';
import BrowseMentorsContent from './browse-mentors-content';
import BrowseMentorsSearch from './browse-mentors-search';
import BrowseMentorsFilters from './browse-mentors-filters';
import { selectLastMentorsFilters, selectLastMentorsSearchTerm } from 'redux/selectors/mentorship-program-participant-driven';
import { css } from '@emotion/react';

const modalStyles = css`
  .close {
    top: 0 !important;
    right: 0 !important;
  }
`;

const BrowseMentorsModal = ({ onClose }: BrowseMentorsModalProps) => {
  const filtersRef = useRef(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const lastSearch = useSelector(selectLastMentorsSearchTerm);
  const lastFilters = useSelector(selectLastMentorsFilters);

  const methods = useForm({
    mode: 'onChange',
    defaultValues: {
      areFiltersSet: false,
      search: lastSearch || '',
      filters: lastFilters || {},
    },
  });
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { id: mentoringProgramId } = mentoringProgram || {};
  const mentoringProgramAliases = useSelector((state) =>
    getMentoringProgramAliases(state, mentoringProgramId)
  );
  const translationBase =
    t.MENTORING_PROGRAMS.PARTICIPANT_HOME.GET_STARTED.FIND_A_MENTOR_MODAL;
  const dataQATag =
    config.pendo.athena.mentorshipProgram.participantHome.findAMentor.modal;

  const handleContentScroll = (e: React.UIEvent<HTMLDivElement>) => {
    setIsScrolled(e.currentTarget.scrollTop > 0);
  };

  const searchPlaceholder = translationBase.SEARCH_PLACEHOLDER();

  return (
    <NvModal
      show
      doubleModal
      fullHeight={false}
      type={ModalType.NO_DIALOG}
      closeDataQa={dataQATag.close}
      modalStyles={modalStyles}
      onClose={onClose}
      closeOnBackdropClick
      body={
        <FormProvider {...methods}>
          <div className='modal-page d-flex flex-column'>
            <BrowseMentorsHeader
              title={translationBase.TITLE(mentoringProgramAliases)}
            />
            <BrowseMentorsSearch placeholder={searchPlaceholder} />
            <BrowseMentorsFilters
              ref={filtersRef}
              isContentScrolled={isScrolled}
            />
            <BrowseMentorsContent
              programId={mentoringProgramId}
              onScroll={handleContentScroll}
              clearFilters={filtersRef.current?.onClearFilters}
            />
          </div>
        </FormProvider>
      }
    />
  );
};

export default BrowseMentorsModal;
